<template>
  <div>
    <base-panel
      :asset="asset"
      :hide-update-button="true"
      :asset-module="assetModule"
      :notifications="notifications"
    >
      <div
        v-if="statusSimulation == ''"
        class="list-templates"
      >
        <div class="d-flex justify-content-end mb-4">
          <b-button
            variant="primary"
            @click="startNewSimulation"
          >
            <span>{{ $t('engineering.templates-simulation.new-simulation') }}</span>
          </b-button>
        </div>

        <TemplateSimulationList
          :items ="listTemplateSimulation.dados"
          :pagination="pagination"
          :loading="loading"
          @refresh-list="getTemplateSimulationList"
          @update:currentPage="currentPageChange"
          @viewSimulation="showSimulation"
          @exportXls="exportExcel"
          @deleteTemplate="deleteTemplateCallReport"
          @editSimulation="callEditSimulation"
        />
      </div>
      <step-by-step
        v-if="statusSimulation != ''"
        horizontal
        :steps="steps"
        :current-step.sync="step"
        :next-disabled="isNextButtonDisabled"
        :conclude-disabled="isSimulationDataDisabled"
        :concludeButtonText="$t('engineering.load-simulation.simulate')"
        :saveTemplateButton="true"
        :saveTemplateButtonText="$t('engineering.load-simulation.save-template')"
        :loading="loading"
        @conclude="onSimulateHandler(false)"
        @saveTemplate="openModalSaveTemplate"
        @backToList="statusSimulation=''"
      >

        <simulation-condition
          :conditions.sync="conditions"
          :paperHumiditySourceData="paperHumiditySourceData"
          :slot="`content:${steps[0].name}`"
          :loading.sync="loading"
          :is-invalid.sync="isSimulationConditionInvalid"
          :is-hysteresis-invalid.sync="isHysteresisInvalid"
          @loadCurrentConditions="changeToggleCurrentConditions"
        />
        <simulation-data
          :slot="`content:${steps[1].name}`"
          :status="status"
          :conditions.sync="conditions"
          :initial-date="conditions.simulationInitialDate"
          :initial-time="conditions.simulationInitialTime"
          :loading.sync="loading"
        />
      </step-by-step>
    </base-panel>
    <save-template-modal
      v-model="showSaveTemplateModal"
      :statusTemplateSituation="statusSimulation"
      :nameTemplateEdit="conditions.name"
      @saveTemplateSimulation="insertTemplateSimulation"
      @editTemplateSimulation="editTemplateSimulation"
    />
  </div>
</template>
<script>
import store from '@/store';
import {
  EndLifeIsolationCriteria,
  LoadSimulationTemperatureCalculationNorm,
  LoadSimulationCoolingCommand,
  LoadSimulationStageSimulationResult as SimulationResult,
  TemplateSimulationSimulationResult,
} from 'sigma-mappings';
import LoadSimulationTab from '@/domain/enums/installation/engineering/loadSimulation/loadSimulationTab';
import DefaultValues from '@/domain/enums/installation/engineering/loadSimulation/loadSimulationDefaultValues';
import BasePanel from '@/domain/components/installation/engineering/BasePanel';
import TemplateSimulationList from '@/domain/components/installation/engineering/loadSimulation/templateSimulation/TemplateSimulationList';
import SaveTemplateModal from '@/app/installation/engineering/modules/loadSimulation/SaveTemplateModal';

import StepByStep from '@/components/stepByStep';
import loadSimulationService from '@/domain/services/installation/engineering/loadSimulation/loadSimulationService';
import SimulationCondition from '@/domain/components/installation/engineering/loadSimulation/simulationCondition/SimulationCondition';
import SimulationData from '@/domain/components/installation/engineering/loadSimulation/simulationData/SimulationData';
import eventBus from '@/services/globalEventBus';
import loadSimulationEvents from '@/domain/events/loadSimulation';
import { mapGetters } from 'vuex';
import {
  formatter as dateTimeFormatter,
  getStartOfDay,
  getNow,
  joinISODateAndTimeString,
} from '@/services/dateTime/datetimeService';
import { formats } from '@/constants/localizer';

const currentDate = getStartOfDay();
const currentTime = dateTimeFormatter(getNow(), formats.TIME_24_SIMPLE);

export default {
  name: 'LoadSimulation',
  props: {
    asset: {
      type: Object,
      default: () => ({}),
    },
    assetModule: {
      type: Object,
      default: () => ({}),
    },
    assetGeneralInfo: {
      type: Object,
      default: () => ({}),
    },
    notifications: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    SimulationData,
    SimulationCondition,
    TemplateSimulationList,
    StepByStep,
    BasePanel,
    SaveTemplateModal,
  },
  data: vm => ({
    statusSimulation: '',
    showSaveTemplateModal: false,
    listTemplateSimulation: {},
    loadCurrentConditions: false,
    loading: false,
    invalidParameters: false,
    step: 0,
    paperHumiditySourceData: null,
    pagination: {
      perPage: 10,
      currentPage: 1,
      totalRows: null,
    },
    steps: [
      {
        labelPath: 'engineering.load-simulation.simulation-condition',
        icon: 'icon-information',
        name: LoadSimulationTab.SIMULATION_CONDITION,
        getConfirmMessageParams: () => vm.showConfirmationMessage,
        onForward: () => vm.onForwardHandler(),
      },
      {
        labelPath: 'engineering.load-simulation.simulation-data',
        icon: 'icon-checked-box',
        name: LoadSimulationTab.SIMULATION_DATA,
      },
    ],
    status: {
      forcedStageCoolingQuantity: DefaultValues.FORCED_STAGE_COOLING_QUANTITY,
      informedMaximumPointsLimit: DefaultValues.INFORMED_MAXIMUM_POINTS_LIMIT,
      simulationMaximumPointsLimit:
        DefaultValues.SIMULATION_MAXIMUM_POINTS_LIMIT,
    },
    isSimulationDataInvalid: true,
    templateConditions: {
      idEdit: null,
      carregarInformacoesAtuais: false,
    },
    conditions: {
      name: '',
      oilInitialTemperature: null,
      windingInitialTemperature: null,
      windingTimeConstant: DefaultValues.WINDING_TIME_CONSTANT,
      windingHotspotFactor: null,
      simulationInitialDate: currentDate,
      simulationInitialTime: currentTime,
      considerHumidity: false,
      paperHumiditySource: null,
      paperHumidity: null,
      referenceHumidityBase: null,
      methodForHumidityCurve: null,
      referenceHumidity: null,
      oilOxygen: null,
      coolingCommand: LoadSimulationCoolingCommand.AUTO,
      stage1: null,
      stage2: null,
      stage3: null,
      stage4: null,
      hysteresisCoolingShutdown: 0,
      oilAlarmTemperature: null,
      oilShutdownTemperature: null,
      windingAlarmTemperature: null,
      windingShutdownTemperature: null,
      normEndLifeCriteria:
        EndLifeIsolationCriteria.IEEEC5791_IEC600767_NBR53567_GP_200_LIFE_150000,
      normTemperatureCalculation:
        LoadSimulationTemperatureCalculationNorm.IEC_600767_EXPONENTIAL,
      enableHumidityParameters: false,
      enablePaperHumidity: false,
      enableReferenceHumidity: false,
      enableOilOxygen: false,
      enableStage1: false,
      enableStage2: false,
      enableStage3: false,
      enableStage4: false,
      enableHysteresis: false,
      isCoolingCommandAuto: false,
      forcedStageCoolingQuantity: 0,
    },
    isSimulationConditionInvalid: true,
    isHysteresisInvalid: false,
    checkResultStatusListener: null,
  }),
  computed: {
    ...mapGetters(['simulationData', 'installation']),
    timeIntervalBetweenPoints() {
      return this.simulationData.interval;
    },
    simulationRepetitionsNumber() {
      return this.simulationData.repetitions;
    },
    totalPointsToSimulate() {
      const pointsLength = (this.simulationData.points || []).length;
      return pointsLength + pointsLength * this.simulationRepetitionsNumber;
    },
    isNextButtonDisabled() {
      if (this.loading) return true;
      return this.isSimulationConditionInvalid || this.invalidParameters;
    },
    isSimulationDataDisabled() {
      if (this.loading) return true;
      return this.isSimulationConditionInvalid
        || this.simulationData.isEmpty
        || this.simulationData.isInvalid
        || this.simulationData.isIntervalInvalid
        || this.simulationData.isRepetitionsInvalid;
    },
    showConfirmationMessage() {
      if (this.conditions.oilShutdownTemperature < this.conditions.oilAlarmTemperature) {
        return {
          code: 'MC054',
          messageParams: {
            0: this.$t('fields.engineering.load-simulation.oil'),
          },
        };
      }

      if (this.conditions.windingShutdownTemperature < this.conditions.windingAlarmTemperature) {
        return {
          code: 'MC054',
          messageParams: {
            0: this.$t('fields.engineering.load-simulation.winding'),
          },
        };
      }

      return null;
    },
    simulationPayload() {
      const {
        oilInitialTemperature,
        windingInitialTemperature,
        windingTimeConstant,
        windingHotspotFactor,
        simulationInitialDate,
        simulationInitialTime,
        considerHumidity,
        paperHumiditySource,
        paperHumidity,
        referenceHumidityBase,
        referenceHumidity,
        methodForHumidityCurve,
        oilOxygen,
        coolingCommand,
        stage1,
        stage2,
        stage3,
        stage4,
        oilAlarmTemperature,
        oilShutdownTemperature,
        windingAlarmTemperature,
        windingShutdownTemperature,
        normEndLifeCriteria,
        normTemperatureCalculation,
      } = this.conditions;

      let { hysteresisCoolingShutdown } = this.conditions;

      const dateTimeInitialSimulation = joinISODateAndTimeString(
        simulationInitialDate,
        simulationInitialTime,
      );
      const { timeIntervalBetweenPoints, simulationRepetitionsNumber } = this;

      const points = this.simulationData.points.map(
        ({ environmentTemperature, loading }) => ({
          environmentTemperature,
          loading,
        }),
      );

      const temperatureStages = {
        stage1:
          coolingCommand === LoadSimulationCoolingCommand.AUTO ? stage1 : null,
        stage2:
          coolingCommand === LoadSimulationCoolingCommand.AUTO ? stage2 : null,
        stage3:
          coolingCommand === LoadSimulationCoolingCommand.AUTO ? stage3 : null,
        stage4:
          coolingCommand === LoadSimulationCoolingCommand.AUTO ? stage4 : null,
      };

      hysteresisCoolingShutdown = coolingCommand === LoadSimulationCoolingCommand.AUTO
        && this.status.forcedStageCoolingQuantity > 0
          ? hysteresisCoolingShutdown
          : null;

      return {
        oilInitialTemperature,
        windingInitialTemperature,
        windingTimeConstant,
        windingHotspotFactor,
        dateTimeInitialSimulation,
        considerHumidity,
        paperHumiditySource,
        paperHumidity,
        referenceHumidityBase,
        referenceHumidity,
        methodForHumidityCurve,
        oilOxygen,
        coolingCommand,
        temperatureStages,
        hysteresisCoolingShutdown,
        oilAlarmTemperature,
        oilShutdownTemperature,
        windingAlarmTemperature,
        windingShutdownTemperature,
        normEndLifeCriteria,
        normTemperatureCalculation,
        timeIntervalBetweenPoints,
        points,
        simulationRepetitionsNumber,
      };
    },
  },
  created() {
    this.getStatus();
    this.getTemplateSimulationList();
  },
  beforeDestroy() {
    this.clearStore();
  },
  methods: {
    currentPageChange(value) {
      this.pagination.currentPage = value;
      this.getTemplateSimulationList();
    },
    newConditions() {
      this.conditions = {
        name: '',
        oilInitialTemperature: null,
        windingInitialTemperature: null,
        windingTimeConstant: DefaultValues.WINDING_TIME_CONSTANT,
        windingHotspotFactor: null,
        simulationInitialDate: currentDate,
        simulationInitialTime: currentTime,
        considerHumidity: false,
        paperHumiditySource: null,
        paperHumidity: null,
        referenceHumidityBase: null,
        methodForHumidityCurve: null,
        referenceHumidity: null,
        oilOxygen: null,
        coolingCommand: LoadSimulationCoolingCommand.AUTO,
        stage1: null,
        stage2: null,
        stage3: null,
        stage4: null,
        hysteresisCoolingShutdown: 0,
        oilAlarmTemperature: null,
        oilShutdownTemperature: null,
        windingAlarmTemperature: null,
        windingShutdownTemperature: null,
        normEndLifeCriteria:
          EndLifeIsolationCriteria.IEEEC5791_IEC600767_NBR53567_GP_200_LIFE_150000,
        normTemperatureCalculation:
          LoadSimulationTemperatureCalculationNorm.IEC_600767_EXPONENTIAL,
        enableHumidityParameters: false,
        enablePaperHumidity: false,
        enableReferenceHumidity: false,
        enableOilOxygen: false,
        enableStage1: false,
        enableStage2: false,
        enableStage3: false,
        enableStage4: false,
        enableHysteresis: false,
        isCoolingCommandAuto: true,
        forcedStageCoolingQuantity: this.conditions.forcedStageCoolingQuantity,
      };
      this.isSimulationConditionInvalid = true;

      this.clearStore();

      return this.conditions;
    },
    startNewSimulation() {
      this.newConditions();
      this.statusSimulation = 'new';
    },
    getTemplateSimulationList() {
      this.loading = true;

      loadSimulationService
        .getListTemplateSimulation(
          this.installation.companyId,
          this.pagination.currentPage,
          this.pagination.perPage,
        )
        .then((data) => {
          this.listTemplateSimulation = data;
          this.pagination.totalRows = data.totalRegistros;
        })
        .catch(() => {
          this.invalidParameters = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openModalSaveTemplate() {
      this.showSaveTemplateModal = true;
    },
    insertTemplateSimulation(nameTemplate) {
      this.onSimulateHandler(true, nameTemplate);
    },
    callEditSimulation(simulation) {
      Object.assign(
        this.conditions,
        new TemplateSimulationSimulationResult(simulation),
      );

      this.conditions.stage1 = this.conditions.temperatureStages.stage1;
      this.conditions.stage2 = this.conditions.temperatureStages.stage2;
      this.conditions.stage3 = this.conditions.temperatureStages.stage3;
      this.conditions.stage4 = this.conditions.temperatureStages.stage4;
      this.conditions.isCoolingCommandAuto = (this.conditions.coolingCommand === 'auto');
      this.conditions.simulationInitialDate = currentDate;
      this.conditions.simulationInitialTime = currentTime;
      this.templateConditions.idEdit = simulation.id;
      this.isSimulationConditionInvalid = false;
      this.statusSimulation = 'edit';
    },
    editTemplateSimulation(nameTemplate) {
      const payload = this.simulationPayload;

      payload.name = nameTemplate;
      payload.moduleId = this.conditions.moduleId;
      payload.loadCurrentInformation = this.conditions.loadCurrentInformation;
      payload.paperHumiditySource = this.conditions.paperHumiditySource;
      payload.referenceHumidityBase = this.conditions.referenceHumidityBase;
      payload.methodForHumidityCurve = this.conditions.methodForHumidityCurve;

      return loadSimulationService
        .updateTemplateSimulation(this.templateConditions.idEdit, payload)
        .then(() => {
          this.$pushAlert({ code: 'MS006' });
          this.templateConditions.idEdit = '';
          this.getTemplateSimulationList();
          this.clearStore();
          this.showSaveTemplateModal = false;
          this.statusSimulation = '';
          this.step = 0;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    changeToggleCurrentConditions(currentConditions) {
      this.loadCurrentConditions = currentConditions;
    },
    setStatus(data) {
      Object.assign(this.status, data);
      const { informedMaximumPointsLimit } = this.status;

      if (
        informedMaximumPointsLimit == null
        || informedMaximumPointsLimit < 1
      ) {
        this.status.informedMaximumPointsLimit = DefaultValues.INFORMED_MAXIMUM_POINTS_LIMIT;
      }
    },
    getApiHumiditySource() {
      const { assetModuleId } = this.$route.params;
      return loadSimulationService
        .getHumiditySource(assetModuleId)
        .then((data) => {
          this.paperHumiditySourceData = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getStatus() {
      const { assetModuleId } = this.$route.params;
      this.loading = true;

      loadSimulationService
        .getStatus(assetModuleId)
        .then((data) => {
          this.setStatus(data);
          this.conditions.forcedStageCoolingQuantity = data.forcedStageCoolingQuantity;
          eventBus.emit(
            loadSimulationEvents.refreshStageQuantity,
            data.forcedStageCoolingQuantity,
          );
          this.getApiHumiditySource();
        })
        .catch(() => {
          this.invalidParameters = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    isHysteresisValueInvalid() {
      if (this.conditions.enableStage1 && this.conditions.stage1) {
        if (
          this.conditions.stage1 <= this.conditions.hysteresisCoolingShutdown
        ) {
          return true;
        }
      }
      return false;
    },
    onForwardHandler() {
      if (this.isHysteresisValueInvalid()) {
        this.$pushAlert({
          code: 'ME068',
          messageParams: {
            0: this.$t('fields.engineering.load-simulation.stage-1'),
            1: this.$t(
              'fields.engineering.load-simulation.hysteresis-cooling-shutdown',
            ),
          },
        });

        this.isHysteresisInvalid = true;
        return false;
      }

      this.scrollToTop();

      return true;
    },
    scrollToTop() {
      const view = document.getElementsByClassName('app__content-wrapper')[0];
      view.scrollTo(0, 0);
    },
    goToResultPage(resultId) {
      const { installationId, assetModuleId } = this.$route.params;

      const routeData = this.$router.resolve({
        name: 'clean-view.load-simulation.simulation-result',
        params: {
          installationId,
          assetModuleId,
          resultId,
        },
      });
      return window.open(routeData.href, '_blank');
    },
    checkResultStatus(resultId) {
      const { assetModuleId } = this.$route.params;

      this.loading = true;

      loadSimulationService
        .getResultStatus(assetModuleId, resultId)
        .then((status) => {
          switch (status) {
            case SimulationResult.SIMULATION_FINISHED_WITH_SUCCESS:
              clearInterval(this.checkResultStatusListener);
              this.loading = false;
              this.goToResultPage(resultId);
              break;
            case SimulationResult.UNDEFINED:
            case SimulationResult.SIMULATION_FINISHED_WITH_WARNINGS:
            case SimulationResult.SIMULATION_ERROR:
              clearInterval(this.checkResultStatusListener);
              this.$pushAlert({ code: 'ME018' });
              this.loading = false;
              break;
            default:
              break;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    showSimulation(simulation) {
      const simulationTemplateData = simulation;

      this.simulate(true, simulationTemplateData);
    },
    simulate(isVisualization, simulation) {
      const { assetModuleId } = this.$route.params;

      this.loading = true;

      if (simulation.comandoResfriamento !== 'Auto') {
        // eslint-disable-next-line no-param-reassign
        simulation.histereseDesligamentoResfriamento = null;
      }

      return loadSimulationService
        .simulation(assetModuleId, isVisualization, simulation)
        .then((resultId) => {
          this.checkResultStatus(resultId);

          this.checkResultStatusListener = setInterval(() => {
            this.checkResultStatus(resultId);
          }, DefaultValues.CHECK_RESULT_STATUS_INTERVAL);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    saveTemplateSimulation(nameTemplate) {
      const { assetModuleId } = this.$route.params;

      const payload = this.simulationPayload;

      payload.name = nameTemplate;
      payload.moduleId = assetModuleId;
      payload.loadCurrentInformation = this.loadCurrentConditions;
      payload.paperHumiditySource = 'Indefinido';
      payload.referenceHumidityBase = 'Indefinido';

      return loadSimulationService
        .insertTemplateSimulation(assetModuleId, payload)
        .then(() => {
          this.$pushAlert({ code: 'MS006' });
          this.getTemplateSimulationList();
          this.clearStore();
          this.statusSimulation = '';
          this.step = 0;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onSimulateHandler(isSaveTemplate, nameTemplate) {
      const { simulationMaximumPointsLimit } = this.status;
      if (this.totalPointsToSimulate > simulationMaximumPointsLimit) {
        return this.$confirmMessage({
          code: 'MC053',
          messageParams: {
            0: this.status.simulationMaximumPointsLimit,
          },
        }).accepted(() => this.simulate(false, this.simulationPayload));
      }

      if (isSaveTemplate) return this.saveTemplateSimulation(nameTemplate);

      return this.simulate(false, this.simulationPayload);
    },
    clearStore() {
      store.dispatch('setSimulationDataReset');
    },
    exportExcel(simulation) {
      const simulationTemplateData = simulation;
      const { assetModuleId } = this.$route.params;

      if (simulationTemplateData.comandoResfriamento !== 'Auto') {
        simulationTemplateData.histereseDesligamentoResfriamento = null;
      }

      return loadSimulationService
        .simulation(assetModuleId, true, simulationTemplateData)
        .then((resultId) => {
          loadSimulationService.downloadResult(assetModuleId, resultId)
          .then(() => {
            this.$pushAlert({ code: 'MS011' });
          });
        });
    },
    deleteTemplateCallReport(item) {
      this.loadingDropdown = item.id;
      loadSimulationService.deleteTemplateSimulation(item.id)
        .then(() => {
          this.$pushAlert({ code: 'MS039', mode: 'toast' });
        })
        .finally(() => {
          this.loadingDropdown = '';
          this.getTemplateSimulationList();
        });
    },
  },
};
</script>
<style lang="sass" scoped>
::v-deep
  .icon-checked-box
    filter: none

  .btn-secondary .icon-checked-box
    filter: brightness(50%)

@media print
  ::v-deep
    .step-by-step-footer
      display: none !important
</style>
